import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import { SignupElementDataType } from '@/components/sections/builder/elements/body/signup/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { Input } from '@/components/ui/input';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSettingSignup({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const content = element.data as SignupElementDataType;

  return (
    <div>
      <div className='mb-1 mt-4 text-sm font-bold md:mt-4'>Section Body</div>
      <p className='mb-2 text-xs'>Layout</p>
      <InputTab
        grid={2}
        defaultValue={content.layout || 'default'}
        options={[
          { label: 'Default', value: 'default' },
          { label: 'Grid', value: 'grid' },
        ]}
        onChange={(value) => {
          builder.setElementData(element.id, {
            layout: value,
          });
        }}
      />
      <p className='mb-2 mt-4 text-xs'>Signup Title</p>
      <TextEditorMinimal
        onChange={(value) =>
          builder.setElementData(element.id, {
            headingLabel: value,
          })
        }
        value={content.headingLabel || 'Create Account'}
        placeholder='Signin Title'
        className='mb-2 w-full max-w-64'
        output='html'
        editorProps={{
          attributes: {
            class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
          },
        }}
        editable
      />
      <p className='mb-2 text-xs'>Button Label</p>
      <Input
        name='buttonLabel'
        defaultValue={content.buttonLabel || 'Sign up'}
        value={content.buttonLabel}
        onChange={(e) => {
          builder.setElementData(element.id, {
            buttonLabel: e.target.value,
          });
        }}
      />
      <div className='mb-1 mt-4 text-sm font-bold md:mt-4'>Section Padding</div>
      <InputSlider
        label='Top padding'
        value={content.topPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            topPadding: val,
          })
        }
      />
      <InputSlider
        label='Bottom padding'
        value={content.bottomPadding}
        onChange={(val) =>
          builder.setElementData(element.id, {
            bottomPadding: val,
          })
        }
      />
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={content.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
    </div>
  );
}
